
<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-autocomplete
      v-model="keyword"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      color="red"
      hide-no-data
      hide-selected
      item-text="varientName"
      item-value="productId._id"
      label="Product List"
      placeholder="Start typing to Search"
      dense
      flat
      @input="getVal()"
      hide-details
      return-object
    ></v-autocomplete>
  </div>
</template>
<script>
import axios from "axios";
// import store from "../../store";
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      keyword: null,
      products: [],
      searchList: [],
      ServerError: false,
      searchKey: null,
      page: 1,
      Pagelength: 0,
      limit: 20,
      isLoading: false,
      model: "",
      items: [],
      search: null,
      result: [],
    };
  },
  // beforeMount() {
  //   this.searchSuggestion();
  // },
  watch: {
    //  keyword()
    //   {
    //     this.searchSuggestion();
    //   },

    search(val) {
      console.log("1");
      axios({
        method: "POST",
        url: "/grocery/admin/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          keyword: val,
          // filterType: "today",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.items = response.data.data;
            // this.keyword2 =this.keyword;
            this.items = response.data.product;

            this.msg = response.data.msg;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          console.log(err);
          this.appLoading = false;
        })
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
   
    getVal() {
      console.log("key=", this.keyword.productId._id);

     

       this.$emit("stepper", {
          ref: "availability",
          key: this.keyword.productId._id,
        });
    },
//   search2(val) {
//       console.log("1");
//       axios({
//         method: "POST",
//         url: "/grocery/admin/products/list",
//         headers: {
//           token: localStorage.getItem("token"),
//         },
//         data: {
//           keyword: val,
//           // filterType: "today",
//         },
//       })
//         .then((response) => {
//           this.appLoading = false;
//           if (response.data.status == true) {
//             this.items = response.data.data;
//             // this.keyword2 =this.keyword;
//             this.items = response.data.product;
// this.getVal()
//             this.msg = response.data.msg;
//           } else {
//             this.snackbar = true;
//             this.msg = response.data.msg;
//           }
//         })
//         .catch((err) => {
//           console.log(err);
//           this.appLoading = false;
//         })
//         .finally(() => (this.isLoading = false));
//     },
  },
};
</script>